import React from 'react';
import CollectionPointBasicInfoComponent from './collection-point-basic-info.component';
import CollectionPointAddressComponent from './collection-point-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function CollectionPointComponent ({ back,handleInnerbasicFormChange, handleFormSubmit, onInnerFormChange, selectedAddress, selectedCollection }: any) {
    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component: <CollectionPointBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            selectedCollection={selectedCollection}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <CollectionPointAddressComponent 
            handleInnerbasicFormChange={handleInnerbasicFormChange}
            selectedAddress={selectedAddress} 
            onInnerFormChange={onInnerFormChange}
             selectedCollection={selectedCollection}
           />,
            isVisible:true,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default CollectionPointComponent;
